import './ImageResponsive.scss';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import React from 'react';

class ImageResponsive extends React.Component {
  createSizes(maxWidth, maxHeight, aspect) {
    const sizes = [];

    const increment = 150;
    for (let width = 150; width <= maxWidth; width += increment) {
      const height = width / aspect;

      if (height >= maxHeight) {
        break;
      }

      sizes.push({
        width: Math.floor(width),
        height: Math.floor(height)
      });
    }

    // Add the biggest possible size, while keeping the desired aspect:
    const naturalAspect = maxWidth / maxHeight;
    if (naturalAspect > aspect) {
      sizes.push({
        width: Math.floor(maxHeight * aspect),
        height: maxHeight
      });
    } else {
      sizes.push({
        width: maxWidth,
        height: Math.floor(maxWidth / aspect)
      });
    }

    return sizes;
  }

  createUrl(src, size, fit) {
    return `${src}?fit=${fit}&w=${size.width}&h=${size.height}`;
  }

  render() {
    const fit = (this.props.fit !== undefined) ? this.props.fit : 'thumb';
    const aspect = this.props.aspect || (this.props.width / this.props.height);
    const sizes = this.createSizes(this.props.width, this.props.height, aspect);
    const src = this.createUrl(this.props.src, sizes[0], fit);
    const srcSet = sizes.map((size) => {
      return `${this.createUrl(this.props.src, size, fit)} ${size.width}w`;
    });

    return (
      <img className={`${this.props.className} contentful-image-responsive lazyload`} data-sizes="auto" data-src={src} data-srcset={srcSet.join(', ')} />
    );
  }
}

ImageResponsive.defaultProps = {
  className: '',
  aspect: 0
};

export default ImageResponsive;
